import { urlBehindTheSeizure } from "./constants";
import {dispatchAnalytics_onClickPopupYes_notUS, dispatchAnalytics_onClickPopupYes_US} from '../modules/analytics';

const apiKeyProd = 'AIzaSyCrur-eaV2dM8TypdpjTK1L2JQPkFd_ma0';

export function googleApiGeocoding() {
    // Attaching standard "Not US" analytics handler by default
    jQuery('.cln2-modal-yes').on('click', dispatchAnalytics_onClickPopupYes_notUS);
  
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const {
          coords: { latitude, longitude },
        } = position;
        // const latitude = '37.09024', longitude='-95.712891'; //US
        jQuery.getJSON(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKeyProd}`,
          { result_type: "country" }, // remove for more detailed info

          (result) => {
            console.log("google geolocation info", result);
            const { results } = result;
            let long_name, short_name;
            if (results && results[0] && results[0].address_components[0]) {
              short_name = results[0].address_components[0].short_name;
            }
            //   $(".chzn-select").val(result.results[0].address_components[0].short_name).trigger("chosen:updated");
            
            if (short_name && short_name === 'US') {
                console.log('countryCode', short_name);
         
                // If US country detection successful, remove default analytics event and replace with US version
                jQuery('.cln2-modal-yes').off('click', dispatchAnalytics_onClickPopupYes_notUS);
                jQuery('.cln2-modal-yes').on('click', function() {
                    dispatchAnalytics_onClickPopupYes_US();
                    window.location.href = urlBehindTheSeizure;
                });
            }
             return short_name;
          }
        ).fail(function (error) {
          alert("google api error" + JSON.stringify(error));
        });
      });
    }
  }

